// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"RE9JMYz7uo4JX5PZHQrWvw==","comment":"_0TBQQFLxSSsjBor56IlbMQ=="};